var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "#AC6ED1",
          d: "M7 12h2v2H7zM9 10h2v2H9zM11 12h2v2h-2zM13 10h2v2h-2zM15 12h2v2h-2z",
        },
      }),
      _c("path", {
        attrs: {
          d: "M21 16l-2.513-6.702A2 2 0 0016.614 8H7.386a2 2 0 00-1.872 1.298L4.5 12M2 16l20 .01",
          stroke: "#2C3143",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }